export default "__VITE_ASSET__DJttosm1__"